import React from "react";
import { NavLink, Outlet } from "react-router-dom";

function CommonContainer({ SUBNAV, children, DISABLED, MAINTITLE }: any) {
  return (
    <div className="w-full rounded-lg">
      {!DISABLED && (
        <header className="w-full p-2 md:p-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 min-h-8 sm:min-h-0 mb-0 shadow-[rgba(99,99,99,0.15)_0px_1px_4px_0px] dark:shadow-slate-900/50 rounded-md transition-colors duration-300 bg-white dark:bg-slate-800 dark:border dark:border-slate-700">
          <div className="flex flex-col sm:flex-row items-start sm:items-center w-full gap-2 sm:gap-3">
            {MAINTITLE && (
              <h3 className="font-semibold text-sm sm:text-base md:text-lg leading-[1.27] font-inter whitespace-nowrap capitalize flex-shrink-0 transition-colors duration-300 text-[rgba(0,0,0,0.654)] dark:text-slate-200">
                {MAINTITLE}
              </h3>
            )}
            {children && (
              <div className="w-full sm:w-auto">
                {children}
              </div>
            )}
            <div className="flex justify-start sm:justify-end w-full sm:w-auto sm:ml-auto gap-1 sm:gap-1.5 overflow-x-auto scrollbar-hide -mx-2 sm:mx-0 px-2 sm:px-0">
              {SUBNAV
                ? SUBNAV?.map((ITEM: any, i: number) => {
                    if (!ITEM.DISABLED) {
                      return (
                        <NavLink
                          key={i}
                          to={ITEM.PATH}
                          className={({ isActive }) =>
                            `inline-flex items-center justify-center relative box-border cursor-pointer select-none align-middle appearance-none uppercase font-['Public_Sans',sans-serif] text-[10px] sm:text-[0.65rem] leading-[1.25] min-w-[48px] sm:min-w-[56px] font-semibold outline-0 rounded-md px-2 py-1 sm:px-3 sm:py-1.5 transition-all duration-300 ease-in-out whitespace-nowrap flex-shrink-0 ${
                              isActive
                                ? "border border-solid border-blue-400 text-blue-600 bg-blue-50 shadow-sm dark:text-blue-300 dark:bg-blue-900/30"
                                : "border border-transparent text-slate-500 hover:text-blue-500 hover:bg-blue-50/50 hover:border-blue-200 dark:text-slate-400 dark:hover:text-blue-300 dark:hover:bg-slate-700/50 dark:hover:border-slate-600 active:scale-95"
                            }`
                          }
                        >
                          {({ isActive }) => (
                            <>
                              <span className="relative z-10">
                                {ITEM.TITLE}
                              </span>
                              {isActive && (
                                <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full bg-blue-400 transition-colors duration-300" />
                              )}
                            </>
                          )}
                        </NavLink>
                      );
                    }
                    return null;
                  })
                : null}
            </div>
          </div>
        </header>
      )}
      <div className="w-full h-full transition-colors duration-300 bg-white dark:bg-slate-900 dark:text-slate-200">
        <Outlet />
      </div>
    </div>
  );
}

export default CommonContainer;
